import { render, staticRenderFns } from "./simulador-modal-restricoes.vue?vue&type=template&id=3c3157f9&"
import script from "./simulador-modal-restricoes.vue?vue&type=script&lang=js&"
export * from "./simulador-modal-restricoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VProgressCircular,VRadio,VRadioGroup,VRow,VSimpleTable,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c3157f9')) {
      api.createRecord('3c3157f9', component.options)
    } else {
      api.reload('3c3157f9', component.options)
    }
    module.hot.accept("./simulador-modal-restricoes.vue?vue&type=template&id=3c3157f9&", function () {
      api.rerender('3c3157f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/simulador-modal-restricoes.vue"
export default component.exports